import { render, staticRenderFns } from "./DamagesCompensationTableHeader.vue?vue&type=template&id=2b53ca79"
import script from "./DamagesCompensationTableHeader.vue?vue&type=script&lang=ts"
export * from "./DamagesCompensationTableHeader.vue?vue&type=script&lang=ts"
import style0 from "./DamagesCompensationTableHeader.vue?vue&type=style&index=0&id=2b53ca79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports